import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[modal-host-comp]'
})
export class ModalHostCompDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
